import { render, staticRenderFns } from "./NominationDialog.vue?vue&type=template&id=6a6a116b&"
import script from "./NominationDialog.vue?vue&type=script&lang=js&"
export * from "./NominationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports